import { TicketFee, Price, Link } from '../models'

export const TicketStatus = {
	RESERVED: 'reserviert',
	PENDING: 'in Bearbeitung',
	FIXED: 'verkauft',
	CANCELLED: 'storniert',
	TO_DELETE: 'ungültig',
}

export interface Ticket {
	uuid: string,
	fees: TicketFee[]
	price: Price
	priceInclFees: Price;
	category: string
	categoryRef: string
	categoryUuid: string
	priceLevel: string
	priceLevelUuid: string
	priceLevelRef: string
	event: string
	eventRef: string
	eventUuid: string
	merchantId: string
	ticketNumber: string
	barcode: string
	creationDate: string
	status: string
	seatIdentifier: string;
	rowNumber: string;
	seatNumber: string;
	block: string;
}



// WEBPACK FOOTER //
// ./src/app/models/ticket.model.ts